import MDBox from "../../components/MDBox";
import React from "react";
import Card from "@mui/material/Card";
import MDButton from "../../components/MDButton";
import CheckCircleIcon from "@mui/icons-material/CheckCircle.js";
import PropTypes from "prop-types";

function CorrectionDisplay({ Corrector, activityId, onEnd }) {
  return (
    <Card
      sx={{
        minWidth: "35%",
        minHeight: "50%",
        maxWidth: "90%",
        maxHeight: "90%",
        p: 2,
        //overflow: "auto",
        display: "flex",
        flexDirection: "column",
        alignItems: "stretch",
      }}
    >
      <MDBox
        sx={{
          p: 1,
          backgroundColor: "lightyellow",
          borderRadius: 2,
          border: "1px solid khaki",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          mb: 1,
          flex: 1,
        }}
      >
        <Corrector activityId={activityId} />
      </MDBox>
      <MDBox sx={{ width: "100%", textAlign: "right" }}>
        <MDButton variant="gradient" color="info" type="submit" onClick={() => onEnd()}>
          Terminer <CheckCircleIcon color={"inherit"} sx={{ ml: 1 }} />
        </MDButton>
      </MDBox>
    </Card>
  );
}

CorrectionDisplay.propTypes = {
  Corrector: PropTypes.func.isRequired,
  activityId: PropTypes.string.isRequired,
  onEnd: PropTypes.func.isRequired,
};

export default CorrectionDisplay;
